export default function simpleSort(arr) {
    return arr.sort((left, right) => left > right ? 1 : -1);
}